import { useEffect, useState } from 'react';
import Select, { createFilter } from 'react-select';
import axios from '../axiosConfig';
import axios2 from 'axios';
import { handleError, toastError } from '../funciones';

function SelectFiltrado(props) {

    const [optionsSelect, setOptionsSelect] = useState([]);

    const filterConfig = {
        stringify: option => `${option.label}`,
    };

    useEffect(() => {
        var axiosAusar
        if (props.url == "empresa/getAllRubros" || props.url == "empresa/todosLosProductos") {
            axiosAusar = axios2
        }
        else {
            axiosAusar = axios
        }
        axiosAusar.get(process.env.REACT_APP_URL + props.url)
            .then(function (response) {
                setOptionsSelect([])
                response.data.map(function (rubro, i) {
                    if (rubro !== "")
                        setOptionsSelect(optionsSelect => [...optionsSelect, { value: i, label: rubro }])
                });
            })
            .catch(function (error) {
                toastError(handleError(error))
            });
    }, [props.reload])

    useEffect(() => {
        //if (props.option !== null && props.option !== undefined)
           // setOptionsSelect(optionsSelect => [...optionsSelect, { value: props.option.value, label: props.option.label }])
        if (props.option == null || props.option == undefined) return;

        setOptionsSelect(prev => {
            if (Array.isArray(props.option)) { 
                return [...prev, ...props.option.map(opt => ({
                    value: opt.value,
                    label: opt.label
                }))];
            } else { 
                return [...prev, {
                    value: props.option.value,
                    label: props.option.label
                }];
            }
        });
    }, [props.option])

    function handleChange(option) {
        //props.setSelectedOption(option); 
        if (option !== null) {
            setOptionsSelect(optionsSelect => optionsSelect.filter(item => item.value !== option.value));

            props.agregarRubro(option)
        }
    }

    return (
        <>
            <div className='mt-1 mb-3 letraDatos text-black'>
                <Select
                    isClearable={true}
                    onChange={handleChange}
                    isSearchable={true}
                    options={optionsSelect}
                    value={""}
                    placeholder={props.placeholder}
                    filterOption={createFilter(filterConfig)}
                />
            </div>
        </>
    );
}
export default SelectFiltrado;